(function () {
  'use strict';

  if (window.__lpwNewNoteworthyInstalled) return;
  window.__lpwNewNoteworthyInstalled = true;

  var destination = 'G-1D1PHC0HTB';
  var listId = 'homepage_new_noteworthy';
  var listName = 'New & noteworthy';
  var states = new Map();
  var viewed = new Set();
  var pendingClicks = [];
  var retryTimer = null;
  var privacyRequested = false;
  var privacyAttempts = 0;

  function allowed() {
    var shopify = window.Shopify || {};
    var role = shopify.theme && shopify.theme.role;
    var preview = shopify.designMode === true
      || /(?:^|[?&])preview_theme_id=/.test(window.location.search)
      || Boolean(role && role !== 'main' && role !== 'live');
    if (preview && !/(?:^|[?&])_lpw_ga_qa=1(?:&|$)/.test(window.location.search)) return false;
    if (!shopify.customerPrivacy && !privacyRequested && privacyAttempts < 3 && typeof shopify.loadFeatures === 'function') {
      privacyRequested = true;
      privacyAttempts += 1;
      // Shopify does not expose this API on every visit until explicitly requested.
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) { privacyRequested = false; return; }
        flush();
      });
    }
    try {
      return Boolean(shopify.customerPrivacy
        && typeof shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
        && shopify.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (error) {
      return false;
    }
  }

  function configured() {
    return typeof window.gtag === 'function'
      && Array.isArray(window.dataLayer)
      && window.dataLayer.some(function (entry) {
        return entry && entry[0] === 'config' && entry[1] === destination;
      });
  }

  function send(name, payload) {
    try {
      window.gtag('event', name, Object.assign({}, payload, {
        send_to: destination,
        transport_type: 'beacon'
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function itemPayload(state, item) {
    return {
      item_list_id: listId,
      item_list_name: listName,
      currency: state.root.dataset.currency,
      items: [Object.assign({}, item, { item_list_id: listId, item_list_name: listName })]
    };
  }

  function flush() {
    window.clearTimeout(retryTimer);
    retryTimer = null;
    var maySend = allowed();
    if (!maySend) pendingClicks = [];
    var ready = maySend && configured();
    var waiting = false;
    if (ready) {
      while (pendingClicks.length && send(pendingClicks[0].name, pendingClicks[0].payload)) {
        pendingClicks.shift();
      }
    }
    states.forEach(function (state) {
      state.visible.forEach(function (card) {
        var item = state.items.get(card);
        var key = state.root.dataset.sectionId + ':' + item.item_id;
        if (viewed.has(key)) return;
        if (!document.hidden && ready && send('view_item_list', itemPayload(state, item))) {
          viewed.add(key);
        } else {
          waiting = true;
        }
      });
    });
    if (waiting || pendingClicks.length) retryTimer = window.setTimeout(flush, 1000);
  }

  function queueClick(name, payload) {
    // Denied clicks are discarded; only currently visible cards are reconsidered after consent.
    if (!allowed()) return;
    pendingClicks.push({ name: name, payload: payload });
    if (pendingClicks.length > 20) pendingClicks.shift();
    flush();
  }

  function init(root) {
    if (states.has(root)) return;
    var state = { root: root, items: new Map(), visible: new Set() };
    root.querySelectorAll('[data-noteworthy-item]').forEach(function (card) {
      try {
        var item = JSON.parse(card.dataset.noteworthyItem);
        if (item.item_id && typeof item.price === 'number') state.items.set(card, item);
      } catch (error) { /* A malformed card must not affect browsing or other cards. */ }
    });
    state.click = function (event) {
      if (!(event.target instanceof Element)) return;
      var link = event.target.closest('a[href]');
      if (!link || !root.contains(link)) return;
      if (link.matches('[data-noteworthy-view-all]')) {
        queueClick('homepage_discovery_click', {
          item_list_id: listId,
          item_list_name: listName,
          link_url: link.href,
          link_text: (link.textContent || '').replace(/\s+/g, ' ').trim()
        });
        return;
      }
      var card = link.closest('[data-noteworthy-item]');
      if (state.items.has(card) && link.classList.contains('js-prod-link')) {
        queueClick('select_item', itemPayload(state, state.items.get(card)));
      }
    };
    root.addEventListener('click', state.click);
    states.set(root, state);
    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) state.visible.add(entry.target);
          else state.visible.delete(entry.target);
        });
        flush();
      }, { threshold: [0, 0.5] });
      state.items.forEach(function (item, card) { state.observer.observe(card); });
    }
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-new-noteworthy]')) init(scope);
    scope.querySelectorAll('[data-new-noteworthy]').forEach(init);
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    states.forEach(function (state, root) {
      if (event.target === root || event.target.contains(root)) {
        if (state.observer) state.observer.disconnect();
        root.removeEventListener('click', state.click);
        states.delete(root);
      }
    });
    flush();
  });
  document.addEventListener('visitorConsentCollected', flush);
  document.addEventListener('visibilitychange', flush);
  window.addEventListener('pagehide', function () {
    flush();
    window.clearTimeout(retryTimer);
    retryTimer = null;
  });
  window.addEventListener('pageshow', flush);
})();
